module.exports = __webpack_public_path__ + "img/MEDIA034.8a48cefb.jpg";